import { Component } from '@angular/core';

@Component({
  selector: 'dhl-breadcrums',
  templateUrl: './breadcrums.component.html',
  styleUrls: ['./breadcrums.component.scss']
})
export class BreadcrumsComponent {

}
